import { Box, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import type { TDistributionDetails } from '@modules/types'
import { CartLyricsOnlyDistributionMethod } from '@modules/api-core'
import { REQUEST_DETAILS_STRINGS } from './strings'

type TLyricsDistributionDetailsProps = {
  distributionDetails: TDistributionDetails[]
}

const DistributionDetailField = ({
  label,
  value,
}: {
  label: string
  value: string | number | null | undefined
}) => (
  <Grid size={6}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" fontWeight={300}>
      {value || '-'}
    </Typography>
  </Grid>
)

export const LyricsDistributionDetails = ({
  distributionDetails,
}: TLyricsDistributionDetailsProps) => {
  if (!distributionDetails.length) return null

  return (
    <Box p={2}>
      <Typography variant="h6" fontWeight={500} mb={1}>
        {REQUEST_DETAILS_STRINGS.distributionMethod}
      </Typography>
      <Stack spacing={2}>
        {distributionDetails.map(detail => (
          <Box key={detail.id} p={2} bgcolor="background.default">
            <Grid container spacing={2}>
              <DistributionDetailField
                label={REQUEST_DETAILS_STRINGS.format}
                value={CartLyricsOnlyDistributionMethod.displayName(
                  detail.productType ?? detail.distributionMethod,
                )}
              />
              <DistributionDetailField
                label={REQUEST_DETAILS_STRINGS.printRun}
                value={detail.numberOfUnits}
              />
              <DistributionDetailField
                label={REQUEST_DETAILS_STRINGS.retailPrice}
                value={detail.retailPrice}
              />
            </Grid>
          </Box>
        ))}
      </Stack>
    </Box>
  )
}
